import React from 'react';
import clsx from 'clsx';
import styles from './BrainzyAccess.module.less';
import { Image } from 'edcom-ui';
import PropTypes from 'prop-types';
import { openKidFrame } from '../../services/util';

export default function BrainzyAccess({ isMobile = false }) {
  return (
    <div
      className={clsx(styles.brainzyAccessContainer, isMobile && styles.mobile)}
    >
      <div className={clsx(styles.brainzyAccess)}>
        <div
          className={styles.brainzyLink}
          role="button"
          tabIndex={0}
          title="Brainzy access for kids"
          onClick={() => openKidFrame('/games/play/')}
          onKeyPress={() => openKidFrame('/games/play/')}
        >
          <div className={styles.button}>
            <div className={styles.buttonInner}>
              <div className={styles.rolyClip}>
                <Image
                  className={styles.roly}
                  src="/files/static/Brainzy/topnav/roly.png"
                  alt=""
                  naturalWidth={160}
                  displayWidth={47}
                />
              </div>
              <Image
                className={styles.kids}
                src="/files/static/Brainzy/topnav/kids.png"
                alt=""
                naturalWidth={300}
                displayWidth={75}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

BrainzyAccess.propTypes = {
  isMobile: PropTypes.bool,
};
